import { z } from 'zod';
import { defineEndpoint } from '../define';
import { UserListItemSchema } from './list';

export const GetUserResponseSchema = z.object({
  data: UserListItemSchema,
});

export const getUser = defineEndpoint({
  method: 'GET',
  path: '/v1/users/:userId',
  params: z.object({ userId: z.string().uuid() }),
  query: z.object({}),
  body: z.undefined(),
  response: GetUserResponseSchema,
});
